<template>
  <!-- 上传组件 -->
  <div class="business-license-upload">
    <!-- 没有图片时显示上传按钮 -->
    <template v-if="!imgSrc">
      <el-upload
        class="avatar-uploader"
        action
        accept=".png,.jpg"
        :show-file-list="false"
        :http-request="handleUpLoadImg"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
    </template>
    <!-- 有图片时显示图片和删除按钮 -->
    <template v-else>
      <div class="avatar-uploader uploaded-image">
        <el-image
          :src="imgSrc"
          class="avatar"
          :preview-src-list="[imgSrc]"
          fit="cover"
        >
        </el-image>
        <!-- 右上角删除按钮 -->
        <div class="delete-btn" @click="removeImg">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { upload3 } from "@/api/common/index";
import { compressImage } from "@/utils/compressImage";

export default {
  name: "Upload",
  props: {
    imgUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imgSrc: "",
      previewDialogVisible: false,
    };
  },
  watch: {
    imgUrl: {
      handler(newVal) {
        this.imgSrc = newVal || "";
      },
      immediate: true, // 关键：立即执行
    },
  },
  methods: {
    handleUpLoadImg(file) {
      compressImage(file.file, 200).then((result) => {
        let formData = new FormData();
        formData.append("FormFile", result);
        upload3(formData).then((res) => {
          if (res.data.isSuccess) {
            let data = res.data.data;
            this.$emit("backUrl", data);
          }
        });
      });
    },
    // 点击删除
    removeImg(e) {
      e.stopPropagation(); // 阻止事件冒泡，避免触发图片预览
      this.$emit("deleteImg", true);
    },
  },
};
</script>

<style scoped>
.business-license-upload {
  width: 100%;
}

.avatar-uploader {
  width: 108px;
  height: 108px;
}

::v-deep .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 108px;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fbfdff;
}

::v-deep .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

::v-deep .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}

.avatar {
  width: 108px;
  height: 108px;
  display: block;
  object-fit: cover;
}

/* 已上传图片容器 */
.uploaded-image {
  position: relative;
  width: 108px;
  height: 108px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}

.uploaded-image .el-image {
  width: 100%;
  height: 100%;
  display: block;
}

.uploaded-image .el-image__inner {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 右上角删除按钮 */
.delete-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 20px;
  height: 20px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 11;
  transition: all 0.2s ease;
}

.delete-btn i {
  font-size: 12px;
  color: #ffffff;
}

.delete-btn:hover {
  background-color: #f56c6c;
  transform: scale(1.1);
}
</style>
